<template>
  <div style="display: contents;">
    <tr role="row" :class="index % 2 === 0 ? 'even' : 'odd'">
      <td
        :class="{'row_active': toggleIsActive }"
        class="sorting_1"
        tabindex="0"
      >{{ data.themeName }}</td>
      <td :class="{'row_active': toggleIsActive }" class="sorting_1 toggle-col" tabindex="0">
        <button
          v-if="!data.hasProductLeaders"
          type="button"
          class="toggle_btn btn btn-product_leaders btn-md btn-icon btn-circle disabled"
        >
          <i class="la la-eye-slash"></i>
        </button>
        <button
          v-else
          @click="toggleView('productLeadersView')"
          type="button"
          :class="{'active': productLeadersView}"
          class="toggle_btn btn btn-product_leaders btn-md btn-icon btn-circle"
        >
          <i class="la la-eye"></i>
        </button>
      </td>
      <td
        :class="{'row_active': toggleIsActive }"
        class="sorting_1"
        tabindex="0"
      >{{ data.parentName }}</td>
      <td
        :class="{'row_active': toggleIsActive }"
        class="sorting_1"
        tabindex="0"
      >{{ data.segmentationName }}</td>

      <td :class="{'row_active': toggleIsActive }" class="sorting_1 toggle-col" tabindex="0">
        <button
          v-if="!data.hasVerbatims"
          type="button"
          class="toggle_btn btn btn-verbatim btn-md btn-icon btn-circle disabled"
        >
          <i class="la la-eye-slash"></i>
        </button>
        <button
          v-else
          @click="toggleView('verbatimView')"
          type="button"
          :class="{'active': verbatimView}"
          class="toggle_btn btn btn-verbatim btn-md btn-icon btn-circle"
        >
          <i class="la la-eye"></i>
        </button>
      </td>
      <td :class="{'row_active': toggleIsActive }" class="sorting_1 toggle-col" tabindex="0">
        <button
          v-if="!data.hasProducts"
          type="button"
          class="toggle_btn btn btn-product btn-md btn-icon btn-circle disabled"
        >
          <i class="la la-eye-slash"></i>
        </button>
        <button
          v-else
          @click="toggleView('productView')"
          type="button"
          :class="{'active': productView}"
          class="toggle_btn btn btn-product btn-md btn-icon btn-circle"
        >
          <i class="la la-eye"></i>
        </button>
      </td>
      <td :class="{'row_active': toggleIsActive }" class="sorting_1 toggle-col" tabindex="0">
        <button
          v-if="!data.productRoles.length"
          type="button"
          class="toggle_btn btn btn-product_roles btn-md btn-icon btn-circle disabled"
        >
          <i class="la la-eye-slash"></i>
        </button>
        <button
          v-else
          @click="toggleView('rolesView')"
          type="button"
          :class="{'active': rolesView}"
          class="toggle_btn btn btn-product_roles btn-md btn-icon btn-circle"
        >
          <i class="la la-eye"></i>
        </button>
      </td>
      <td :class="{'row_active': toggleIsActive }" class="sorting_1 toggle-col" tabindex="0">
        <button
          v-if="!data.patentRoles.length"
          type="button"
          class="toggle_btn btn btn-product_roles btn-md btn-icon btn-circle disabled"
        >
          <i class="la la-eye-slash"></i>
        </button>
        <button
          v-else
          @click="toggleView('patentRolesView')"
          type="button"
          :class="{'active': patentRolesView}"
          class="toggle_btn btn btn-product_roles btn-md btn-icon btn-circle"
        >
          <i class="la la-eye"></i>
        </button>
      </td>
      <td :class="{'row_active': toggleIsActive }" nowrap>
        <template v-if="fullProductManagementAccess">
          <a
            @click.prevent="toggleCRUDMode(data)"
            href="#"
            style="color:black;"
            class="btn btn-md btn-clean btn-icon btn-icon-md"
          >
            <i class="fa flaticon-edit"></i>
          </a>
          <a
            @click.prevent="deleteItem(data, index)"
            href="#"
            style="color:red;"
            class="btn btn-md btn-clean btn-icon btn-icon-md"
          >
            <i class="fa flaticon-circle"></i>
          </a>
        </template>
      </td>
    </tr>

    <extra-infos-row
      field="verbatimConsos"
      :data="data"
      :index="index"
      v-show="verbatimView"
      v-if="verbatimView && data.verbatims.length"
    ></extra-infos-row>
    <extra-infos-row
      field="products"
      :data="data"
      :index="index"
      v-show="productView"
      v-if="productView && data.products.length"
    ></extra-infos-row>
    <extra-infos-row
      field="productRoles"
      :data="data"
      :index="index"
      v-show="rolesView"
      v-if="rolesView && data.productRoles.length"
    ></extra-infos-row>
    <extra-infos-row
      field="patentRoles"
      :data="data"
      :index="index"
      v-show="patentRolesView"
      v-if="patentRolesView && data.patentRoles.length"
    ></extra-infos-row>
    <extra-infos-row
      field="productLeaders"
      :data="data"
      :index="index"
      v-show="productLeadersView"
      v-if="productLeadersView && data.productLeaders.length"
    ></extra-infos-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { HTTP } from '../../../assets/js/axiosConfig';
import ExtraInfosRow from './ExtraInfosRow';

import updateFirestore from '../../../assets/js/mixins';

export default {
  props: ['fields', 'data', 'index'],
  mixins: [updateFirestore],
  components: {
    ExtraInfosRow,
  },
  data() {
    return {
      productView: false,
      verbatimView: false,
      rolesView: false,
      patentRolesView: false,
      productLeadersView: false,
      hasProducts: false,
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      crudData: (store) => store.crudData.cruds,
    }),
    ...mapGetters(['fullProductManagementAccess']),
    toggleIsActive() {
      return (
        this.productView
        || this.verbatimView
        || this.rolesView
        || this.patentRolesView
        || this.productLeadersView
      );
    },
  },
  methods: {
    ...mapActions(['toggleCRUDMode']),
    toggleView(column) {
      this[column] = !this[column];
    },
    deleteItem(item) {
      this.toggleCRUDMode(null);
      this.alertAction(this.deleteRequest, 'delete_action_warning', item);
    },
    deleteRequest(item) {
      // Send delete request
      HTTP.delete(`api/segmentations/${item.segmentation_id}`)
        .then(() => {
          // Remove the item from the table on success
          this.keywords = '';
          this.updateFirestore(
            'segmentations',
            item.segmentation_id,
            item.name,
            'delete',
          );
        })
        .catch((err) => {
          const message = err.response.data.message
            ? err.response.data.message
            : this.labels.error_deleting + item.name;
          this.sweetAlert('error', message, 2000);
        });
    },
    closeAllChildren() {
      this.productView = false;
      this.verbatimView = false;
      this.rolesView = false;
      this.patentRolesView = false;
      this.productLeadersView = false;
    },
  },
};
</script>

<style scoped>
.toggle_btn {
  padding: 5.5px 7.8px 8.5px 8.3px;
  border-radius: 36px;
}
.toggle_btn.btn-product {
  background: rgba(253, 57, 122, 0.1);
  color: #fd397a;
}

.toggle_btn.btn-product.active {
  background: #fd397a;
  color: #ffffff;
}

.toggle_btn.btn-product_roles {
  background: rgba(255, 184, 34, 0.1);
  color: #ffb822;
}

.toggle_btn.btn-product_roles.active {
  background: #ffb822;
  color: #ffffff;
}

.toggle_btn.btn-verbatim {
  background: rgba(85, 120, 235, 0.1);
  color: #5578eb;
}

.toggle_btn.btn-verbatim.active {
  background: #5578eb;
  color: #ffffff;
}

.toggle_btn.btn-product_leaders {
  background: rgba(10, 187, 135, 0.1);
  color: #0abb87;
}

.toggle_btn.btn-product_leaders.active {
  background: #0abb87;
  color: #ffffff;
}

.toggle-col {
  text-align: center;
}

.row_active {
  background-color: #ecedf2;
}
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/ChildSegmentationRow.vue